import cn from 'classnames';
import PopOverQuestionMark from '~/components/common/popover-question-mark';
import { Switch } from './switch';
import { useState } from 'react';
type Error = {
   message: string;
};
type InputLayoutProps = {
   groupClassName?: string;
   labelClassName?: string;
   label?: React.ReactNode;
   description?: React.ReactNode;
   error?: any;
   valid?: React.ReactNode;
   children?: React.ReactNode;
   id?: string;
   inputInfo?: string;
   isRequired?: boolean;
   helperText?: React.ReactNode;
   isInputHidable?: boolean;
};

export const InputLayout = ({
   error,
   valid,
   groupClassName,
   labelClassName,
   children,
   label,
   description,
   inputInfo,
   id,
   isRequired,
   helperText,
   isInputHidable,
}: InputLayoutProps) => {
   const [showInput, setShowImput] = useState(isInputHidable ? false : true);
   return (
      <div className={cn('mb-2', groupClassName)}>
         {(label || description) && (
            <div className="mb-2">
               {label && (
                  <div className="flex justify-between items-center">
                     <div className="flex gap-3 items-center">
                        {' '}
                        <label
                           htmlFor={id}
                           className={cn(
                              'flex items-center gap-1 font-semibold sm:text-base',
                              labelClassName
                           )}>
                           {label} {isRequired && <span className="text-red"> *</span>}
                        </label>
                        {helperText ? <PopOverQuestionMark content={helperText} /> : null}
                     </div>
                     {isInputHidable ? (
                        <Switch
                           id={id || 'input'}
                           open={showInput}
                           onChange={() => setShowImput(!showInput)}
                        />
                     ) : null}
                  </div>
               )}
               {description && (
                  <div className="text-xs text-gray-500 sm:text-sm">{description}</div>
               )}
            </div>
         )}
         {showInput ? children : null}

         {valid && !error && typeof valid !== 'boolean' && (
            <div className="mt-1 text-xs text-green-600">{valid}</div>
         )}
         {
            !inputInfo &&
               error &&
               Array.isArray(error) &&
               (error as unknown as Error[])?.map((err, i) => (
                  <div key={i} className="mt-1 text-xs text-states-error">
                     {err?.message ? err?.message : ''}
                  </div>
               ))
            // <div className="mt-1 text-xs text-states-error">{error}</div>
         }
         {!inputInfo && error && typeof error !== 'boolean' && !Array.isArray(error) && (
            <div className="mt-1 text-xs text-states-error">{error}</div>
         )}
         {inputInfo && (
            <div className={cn(error && 'mt-5 text-states-error', 'text-black text-sm')}>
               {error ? error : inputInfo}
            </div>
         )}
      </div>
   );
};
